import { useState } from "react";
import { Icon, Tooltip, Typography } from "@/components/atoms";
import { HowOffloadingWorksModal } from "./HowOffloadingWorksModal";

/**
 * "Vehicle Category" table header: category tooltip carries a link into the
 * "How offloading works" explainer modal, so the tooltip must be interactive
 * (stays open while hovered).
 */
export const VehicleCategoryColumnHeader = () => {
  const [showOffloading, setShowOffloading] = useState(false);

  return (
    <>
      <div className="flex flex-col">
        <div className="flex items-center gap-1">
          Vehicle Category
          <Tooltip
            interactive
            content={
              <span>
                RideMinder&apos;s system category used for matching vehicles to network jobs.{" "}
                <button type="button" className="underline" onClick={() => setShowOffloading(true)}>
                  Click here
                </button>{" "}
                to understand how offloading works.
              </span>
            }
          >
            <Icon name="InfoCircle" size="sm" variant="Bold" className="text-neutral-dark-gray" />
          </Tooltip>
        </div>
        <Typography variant="small-regular" className="font-normal text-neutral-dark-gray">
          As seen by the system
        </Typography>
      </div>
      <HowOffloadingWorksModal open={showOffloading} onClose={() => setShowOffloading(false)} />
    </>
  );
};
